var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.webinars), function(training, index) {
    return _c('training-card', {
      key: index,
      attrs: {
        "title": training.title,
        "link": training.link,
        "date": training.date,
        "poster": training.poster
      }
    })
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cd70a18","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/webinars/Webinars.vue
// module id = 1043
// module chunks = 0